import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { GatewaysCreate } from './GatewaysCreate/GatewaysCreate';
import { GatewaysEdit } from './GatewaysEdit/GatewaysEdit';
import { GatewaysList } from './GatewaysList/GatewaysList';
import { GatewaysShow } from './GatewaysShow/GatewaysShow';

export const gatewaysResource: ResourceProps = {
  name: Resources.Gateways,
  create: GatewaysCreate,
  edit: GatewaysEdit,
  list: GatewaysList,
  show: GatewaysShow,
};
